import * as React from 'react';
import { useField } from 'formik';
import FieldWrapper, { FieldWrapperProps } from '../FieldWrapper';

type Props = {
  // name: string;
  // className?: string;
  // description?: string;
  // disabled?: boolean;
  // fast?: boolean;
  // placeholder?: string;
  options: { label: string; value: string }[];
} & Omit<FieldWrapperProps, 'children'>;
export default function RadioGroup({
  name,
  labelClass,
  labelText,
  required,
  containerClass,
  description,
  options,
}: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, _meta, helpers] = useField({ name });
  return (
    <FieldWrapper {...{ description, name, labelClass, containerClass, labelText, required }}>
      <div className="flex flex-col">
        {options.map(({ label, value }) => (
          <div key={`${name}-${value}`} className="flex items-center gap-1">
            <input
              type="radio"
              id={`${name}-${value}`}
              name={value}
              value={value}
              checked={field.value === value}
              onChange={event => {
                helpers.setValue(event.target.value);
              }}
            />
            <label htmlFor={`${name}-${value}`}>{label}</label>
          </div>
        ))}
      </div>
    </FieldWrapper>
  );
}
